import React, { useEffect, useRef } from 'react';
import cx from 'classnames';
import { observer } from '@formily/react';
import { useCssInJs } from "../../../../hooks";
import { genChoiceModalStyles } from "./styles";
import { Input, List, Button, Modal, ConfigProvider, Empty } from 'antd';
import VirtualList from 'rc-virtual-list';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { useSelectStore } from "../../useSearchList";
import { SearchList } from "../SearchList";
import { TreeView } from "../TreeView";
var ContainerHeight = 400;
export var ChoiceModal = observer(function (props) {
  var prefix = 'form-batch-picker-choice-modal';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genChoiceModalStyles
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var listRef = useRef(null);
  var isModalOpen = props.isModalOpen,
    setIsModalOpen = props.setIsModalOpen,
    onOk = props.onOk,
    onCancel = props.onCancel;
  var store = useSelectStore();
  var mode = store.mode,
    deleteSelected = store.deleteSelected,
    keyword = store.keyword;
  useEffect(function () {
    // 当items变化时，滚动到列表顶部

    if (listRef.current) {
      // 有新的选中项时，滚动到顶部
      listRef.current.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [store.selected]);
  var onScroll = function onScroll(e) {
    if (Math.abs(e.currentTarget.scrollHeight - e.currentTarget.scrollTop - ContainerHeight) <= 1) {
      // TODO: 目前加载了所有数据
      // appendData()
    }
  };
  var handleOk = function handleOk() {
    setIsModalOpen(false);
    if (onOk) {
      onOk(store.selected);
    }
  };
  var handleCancel = function handleCancel() {
    setIsModalOpen(false);
    if (onCancel) {
      onCancel();
    }
  };
  var handleDelete = function handleDelete(e, item) {
    e.preventDefault();
    e.stopPropagation();
    deleteSelected(item);
  };
  var handleSearch = function handleSearch(ev) {
    ev.preventDefault();
    var currentVal = ev.target.value;
    // 如果value.target.value为空，则展示树形结构
    if (currentVal === '') {
      store.showSearch = false;
    } else {
      store.showSearch = true;
    }
    store.keyword = currentVal;
  };
  return wrapSSR( /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, prefix)
  }, /*#__PURE__*/React.createElement(ConfigProvider, {
    theme: {
      components: {
        Modal: {
          contentBg: 'gray'
        }
      }
    }
  }, /*#__PURE__*/React.createElement(Modal, {
    open: isModalOpen,
    onOk: handleOk,
    onCancel: handleCancel,
    width: 800,
    closable: false,
    footer: null,
    maskClosable: false,
    className: cx('noPaddingModal', hashId)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(prefix, hashId)
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, "\u9009\u62E9", mode === 'store' ? '门店' : '人员'), /*#__PURE__*/React.createElement("div", {
    className: "searchInputWrap"
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: mode === 'store' ? '搜索门店名称' : '搜索人员姓名',
    className: "searchInput",
    allowClear: true,
    suffix: /*#__PURE__*/React.createElement(SearchOutlined, null),
    value: keyword,
    onChange: handleSearch
  }))), store.showSearch ? /*#__PURE__*/React.createElement(SearchList, null) : /*#__PURE__*/React.createElement(TreeView, null)), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "selectedCount"
  }, "\u5DF2\u9009", store.selectedCount, mode === 'store' ? '家门店' : '人'), /*#__PURE__*/React.createElement("div", {
    className: "listWrap"
  }, store.selected.length > 0 ? /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(VirtualList, {
    ref: listRef,
    data: store.selected,
    height: ContainerHeight,
    itemHeight: 47,
    itemKey: "value",
    onScroll: onScroll
  }, function (item) {
    return /*#__PURE__*/React.createElement(List.Item, {
      key: item.value,
      className: "listItem"
    }, /*#__PURE__*/React.createElement("div", {
      className: "itemContent"
    }, /*#__PURE__*/React.createElement("div", {
      className: "title"
    }, item.label), mode === 'user' ? /*#__PURE__*/React.createElement("div", {
      className: "subTitle"
    }, " ", item.path) : null), /*#__PURE__*/React.createElement("div", {
      className: "itemClose",
      onClick: function onClick(ev) {
        handleDelete(ev, item);
      }
    }, /*#__PURE__*/React.createElement(CloseOutlined, null)));
  })) : /*#__PURE__*/React.createElement("div", {
    className: "emptyWrap"
  }, /*#__PURE__*/React.createElement(Empty, {
    description: "\u6682\u672A\u9009\u62E9".concat(mode === 'store' ? '门店' : '人员')
  }))), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    onClick: handleCancel
  }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    block: true,
    onClick: handleOk
  }, "\u786E\u5B9A"))))))));
});